import { ExpandMore } from '@mui/icons-material';
import ProductionPlanTable from '../../../../../components/commonComponent/ProductionPlanTable';
import { useEffect } from 'react';

interface AccordionProps {
  tabValue : number;
  openIndices: number[];
  setOpenIndices: React.Dispatch<React.SetStateAction<number[]>>;
  handleToggle: (index: number) => void;
  dayPartIndex : number;
  dayPartDish : any;
  searchTerm: string;
}

const Accordion: React.FC<AccordionProps> = ({tabValue, openIndices, setOpenIndices, handleToggle, dayPartIndex,dayPartDish,searchTerm }) => {
  
  const dishesList = dayPartDish?.disheslist?.filter((dish:any)=>dish?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()));

  useEffect(() => {
    if (searchTerm?.trim()?.length) {
      if (!!dishesList?.length) {
        const findopenIndice = openIndices?.some((indice: any) => indice == dayPartIndex);
        if (!findopenIndice) {
          setOpenIndices(prev => [...prev, dayPartIndex])
        }
      } else {
        setOpenIndices([]);
      }
    } else {
      setOpenIndices([0]);
    }
  }, [searchTerm, tabValue]);
  
  return (
    <>
      <div className={`innrBox ${openIndices.includes(dayPartIndex) ? 'active' : ''}`}>
        <div className='flex align-items-center justify-content-between'>
          <button
            onClick={() => handleToggle(dayPartIndex)}
            className={`flex align-items-center dropDownButton wd-140 ${
              openIndices.includes(dayPartIndex) ? 'active' : ''
            }`}
          >
            <span>
              <ExpandMore />
            </span>{' '}
            {dayPartDish?.name}
          </button>          
        </div>
        {openIndices.includes(dayPartIndex) && (
          <div className='content'>            
            <div className='nested-content'>
              <ProductionPlanTable
               dishListData={dishesList}
               isCategoryAvailable={dayPartDish?.iscategoryavailable}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Accordion;
